import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { useDashboardLinks } from "@core/hooks/useDashboardLinks";
import { useCurrentUser } from "@core/hooks/useCurrentUser";
import { useAuthActions } from "@core/hooks/useAuthActions";
import { t } from "i18next";
import { Link, useNavigate } from "@remix-run/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut } from "@fortawesome/pro-light-svg-icons";
import { DynamicFontAwesomeIcon } from "@core/components/ui/DynamicFontAwesomeIcon";

const MiniMenuExtension = () => {
  const { user } = useCurrentUser();
  const links = useDashboardLinks();
  const { logout } = useAuthActions();
  const navigate = useNavigate();

  const closeDrawer = () => {
    document.querySelector<HTMLElement>(".mini-menu-close")?.click();
  };

  if (!user) return null;

  return (
    <nav className="md:hidden w-full text-sm" aria-label="Account menu">
      {links
        ?.sort((a, b) => a.SortOrder - b.SortOrder)
        .map((group) => (
          <section key={group.GroupName} className="mb-6 last:mb-0">
            <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2 px-1">
              {group.GroupNameKey
                ? t(group.GroupNameKey, group.GroupNameKeyFallback ?? group.GroupName)
                : group.GroupName}
            </h2>
            <ul className="space-y-0.5">
              {group.DashboardRoutes.filter((x) => !x.HideFromMiniMenu).map((link) => (
                <li key={link.Route}>
                  <Link
                    to={link.Route}
                    onClick={closeDrawer}
                    className="flex items-center gap-3 py-2.5 px-3 rounded-md hover:bg-muted/60 transition-colors"
                  >
                    <DynamicFontAwesomeIcon
                      name={link.Icon}
                      fixedWidth
                      className="w-4 text-muted-foreground shrink-0"
                    />
                    <span>
                      {link.TitleKey
                        ? t(link.TitleKey, link.TitleKeyFallback ?? link.Title)
                        : link.Title}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      <hr className="my-4 border-border" />
      <button
        type="button"
        onClick={() => {
          closeDrawer();
          logout.mutate({
            onSuccessCallback: () => navigate("/"),
          });
        }}
        className="flex items-center gap-3 py-2.5 px-3 rounded-md hover:bg-muted/60 transition-colors w-full text-left"
      >
        <FontAwesomeIcon icon={faSignOut} fixedWidth className="w-4 text-muted-foreground shrink-0" />
        <span>{t("ui.logOut", "Log Out")}</span>
      </button>
    </nav>
  );
};
registerExtension("_site.route.minimenu", MiniMenuExtension, "MiniMenu");
